// extracted by mini-css-extract-plugin
module.exports = {"printable_invoice":"print_printable_invoice__3OPr2"};